import React, { FunctionComponent } from 'react';
import { DatePicker } from '@vwfs-bronson/bronson-react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import { FormField } from '../FormField/FormField';

interface Props {
  disabled?: any;
  label?: any;
  maxDate?: any;
  minDate?: any;
  name: string;
  required?: boolean;
  placeholder?: any;
  mode?: string;
}

export const DatePickerField: FunctionComponent<Props> = ({
  name,
  label,
  maxDate,
  minDate,
  required,
  placeholder,
  mode = 'single',
}) => {
  const { setFieldValue, values } = useFormikContext();
  return (
    <FormField
      name={name}
      type="other"
      labelText={label}
      required={required}
      render={(fieldProps) => (
        <DatePicker
          {...fieldProps}
          name={name}
          datePickerClassName="c-input__disabled-validation"
          minDate={minDate}
          maxDate={maxDate}
          dateFormat="d/m/Y"
          locale="fr"
          placeholder={placeholder}
          maskedInput={false}
          mode={mode}
          value={get(values, name, '')}
          onChange={(e) => setFieldValue(name, e)}
          onBlur={(e) => setFieldValue(name, e)}
        />
      )}
    />
  );
};
